<div class="card">
  <div class="card-header d-flex justify-content-between align-items-center">
    <div class="card-header-title">
      <h2 class="my-0" style="color: #224261">{{ 'terminal_terminal' | translation }}</h2>
    </div>
  </div>
  <div class="card-body">
    <h3 *ngIf="!terminal">{{ 'reports_select_device' | translation }}</h3>
    <form *ngIf="terminal" [formGroup]="terminalForm" (ngSubmit)="onSubmit()">
      <h6 class="fs-5">{{ 'reports_currency' | translation }}</h6>
      <mat-form-field appearance="fill" class="w-100">
        <mat-label>{{ 'reports_currency' | translation }}</mat-label>
        <mat-select formControlName="currency">
          <mat-option *ngFor="let currency of currencies" [value]="currency.code">
            {{ currencyName(currency) }} ({{ currency.symbol }})
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="d-flex justify-content-end mt-3">
        <button type="submit" class="btn btn-primary" [disabled]="!terminalForm.valid || !isDirty">
          {{ 'save' | translation }}
        </button>
      </div>
    </form>
  </div>
</div>
